import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "chevron-right",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8.17578 2.35196L15.3281 9.81681C15.5027 9.99747 15.5894 10.2317 15.5894 10.4649C15.5894 10.6981 15.5027 10.9324 15.3281 11.1129L8.17578 18.5777C7.81828 18.9525 7.225 18.9647 6.85156 18.6058C6.47559 18.2494 6.46336 17.6535 6.82349 17.2812L13.386 10.4296L6.82461 3.64845C6.46449 3.27735 6.47672 2.68048 6.85268 2.32384C7.22617 1.96485 7.82031 1.97735 8.17578 2.35196Z",
			fill: "black"
		})
	})
});
export default SvgChevronRight;
